var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCardOptionLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78.52,
    height: 78.52,
    viewBox: "0 0 78.52 78.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.446,44a2.427,2.427,0,0,1-1.734-.72,2.468,2.468,0,0,1,0-3.468l39.1-39.1A2.452,2.452,0,1,1,43.276,4.18L4.18,43.308A2.477,2.477,0,0,1,2.446,44Z",
    transform: "translate(10.412 10.412)",
    fill: "#f0a13d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M2.446,8.825a2.427,2.427,0,0,1-1.734-.72,2.468,2.468,0,0,1,0-3.468L4.638.712A2.452,2.452,0,0,1,8.106,4.18L4.18,8.106A2.451,2.451,0,0,1,2.446,8.825Z",
    transform: "translate(33.87 53.434)",
    fill: "#f0a13d"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M2.446,12.719A2.427,2.427,0,0,1,.712,12a2.468,2.468,0,0,1,0-3.468L8.531.712A2.452,2.452,0,0,1,12,4.18L4.18,12A2.51,2.51,0,0,1,2.446,12.719Z",
    transform: "translate(42.67 40.74)",
    fill: "#f0a13d"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M32.209,70.324C29,70.324,25.8,68.361,21.9,64.468L5.84,48.4c-7.819-7.819-7.787-12.858.1-20.742L27.662,5.938c7.885-7.885,12.923-7.917,20.742-.1L64.468,21.9c7.819,7.819,7.787,12.858-.1,20.742L42.646,64.37C38.687,68.328,35.448,70.324,32.209,70.324ZM38.1,4.891c-1.7,0-3.861,1.407-6.969,4.515L9.406,31.13C6.3,34.238,4.891,36.4,4.891,38.066c0,1.7,1.309,3.762,4.417,6.87L25.372,61c3.108,3.108,5.136,4.417,6.838,4.417h.033c1.7,0,3.828-1.407,6.936-4.515L60.9,39.178c3.108-3.108,4.515-5.267,4.515-6.936,0-1.7-1.309-3.762-4.417-6.87L44.936,9.308C41.861,6.2,39.8,4.891,38.1,4.891Z",
    transform: "translate(4.106 4.106)",
    fill: "#f0a13d"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M67.887,4.907H2.454A2.472,2.472,0,0,1,0,2.454,2.472,2.472,0,0,1,2.454,0H67.887A2.472,2.472,0,0,1,70.34,2.454,2.472,2.472,0,0,1,67.887,4.907Z",
    transform: "translate(4.09 69.522)",
    fill: "#f0a13d"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-6",
    "data-name": "Vector",
    d: "M0,0H78.52V78.52H0Z",
    fill: "none",
    opacity: 0
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardOptionLogo);
export default __webpack_public_path__ + "static/media/CardOptionLogo.68bac2eaca78d54b7ea8c8cf23a5d907.svg";
export { ForwardRef as ReactComponent };